<template>
  <div>
    <!-- Kiosk Password and Expiry Date Section -->
    <b-card title="Kiosk Settings" class="mb-3">
      <b-row>
        <!-- Kiosk Password Column -->
        <b-col md="6">
          <h5>Kiosk Password</h5>
          <b-modal
            id="promptUpdate"
            ref="modal"
            v-model="promptPasswordUpdate"
            title="Update Password"
            hide-footer
          >
            <b-form>
              <b-card-actions-container class="bv-edit-password">
                <b-row>
                  <b-col cols="12">
                    <b-form-group>
                      <label id="edit-dashboard-old-password" for="edit-dashboard-old-password">Old Password</label>
                      <b-form-input
                        id="edit-dashboard-old-password-input"
                        v-model="oldPassword"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="12">
                    <b-form-group>
                      <label id="edit-dashboard-new-password" for="edit-dashboard-new-password">New Password</label>
                      <b-form-input
                        id="edit-dashboard-new-password-input"
                        v-model="password"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group>
                      <label id="edit-edit-show-password" for="edit-show-password">Show Password</label>
                      <b-input-group-append is-text id="edit-show-password">
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-form-group>
                  </b-col>
                  
                  <b-col cols="12">
                    <!-- Solid divider -->
                    <hr class="solid">
                  </b-col>               
                </b-row>
              </b-card-actions-container>
              <div class="w-100">
                <b-button @click="updatePassword" class="float-right" variant="primary">Submit</b-button>  
              </div>
              <div class="w-100">
                <b-button @click="this.promptPasswordUpdate=false" class="float-right" variant="danger">Cancel</b-button>  
              </div>
            </b-form>
          </b-modal>
          <b-row class="mb-2">
            <b-col cols="4">
              Last Updated
            </b-col>
            <b-col cols="8">
              {{ dates(kioskPassword.updatedAt) }}
            </b-col>
            <b-col cols="4">
              Last Updated By
            </b-col>
            <b-col cols="8">
              {{ kioskPassword.updatedBy }}
            </b-col>
            <b-col cols="12" class="mt-2">
              <b-button variant="success" @click="promptPasswordUpdate=true">Update</b-button>
            </b-col>
          </b-row>
        </b-col>
        
        <!-- Kiosk Expiry Date Column -->
        <b-col md="6">
          <h5>eKiosk Online Order expired setting</h5>
          <b-toast
            v-model="showExpirySnackbar"
            :variant="expirySnackbarColor"
            :title="expirySnackbarColor === 'success' ? 'Success' : 'Failed'"
            solid
          >
            {{ expirySnackbarMessage }}
          </b-toast>
          
          <b-card-actions-container>
            <b-row>
              <b-col cols="12" md="12">
                <b-form-group>
                  <label for="expiry-days">Expiry Days</label>
                  <b-form-input
                    id="expiry-days"
                    v-model="expiryDays"
                    type="number"
                    placeholder="Enter number of days"
                    class="my-1"
                  />
                  <small>default as 0 if no expiry days required</small>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12" class="mt-2">
                <b-button
                  variant="primary"
                  @click="saveExpiryDays"
                  class="me-2 my-1"
                >
                  Save
                </b-button>
              </b-col>
            </b-row>
          </b-card-actions-container>
        </b-col>
      </b-row>
    </b-card>

    <!-- Ticketing Text Section -->
    <b-card title="Running text Setting on Queue Display" class="mb-3">
      <b-toast
        v-model="showSnackbar"
        :variant="snackbarColor"
        :title="snackbarColor === 'success' ? 'Success' : 'Failed'"
        solid
      >
        {{ snackbarMessage }}
      </b-toast>
      
      <b-card-actions-container>
        <b-row>
          <b-col cols="12" md="12">
            <b-form-group>
              <label for="running-text">Running Text</label>
              <b-form-input
                id="running-text"
                v-model="runningText"
                placeholder="Enter running text"
                class="my-1"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="12" class="mt-2">
            <b-button
              variant="primary"
              @click="saveRunningText"
              class="me-2 my-1"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-card-actions-container>
    </b-card>

    <!-- Banner Section -->
     <b-card title="Kiosk Pannel Banner Setting" class="mb-3">
      <b-toast
        v-model="showSnackbarBanner"
        :variant="snackbarColorBanner"
        :title="snackbarColorBanner === 'success' ? 'Success' : 'Failed'"
        solid
      >
        {{ snackbarMessageBanner }}
      </b-toast>

      <b-card-actions-container>
        <b-row>
          <!-- <b-col cols="12" md="12">
            <b-form-group label="Show Banner">
              <b-form-checkbox v-model="bannerSettings.isActive">
                Enable Banner on Kiosk Panel
              </b-form-checkbox>
            </b-form-group>
          </b-col> -->

          <b-col cols="12" md="12">
            <b-form-group label="Upload Banner Image">
              <b-form-file
                @change="handleFileUpload"
                accept="image/*"
                browse-text="Choose File"
                :placeholder="bannerSettings.base64Image ? 'Banner image loaded' : 'No file chosen'"
              ></b-form-file>
              <br>
              <div class="mt-1">
                <span style="color:red; margin-top: 2px;" >*Only allowed .png/ .jpg/ .jpeg file (max file size is 1MB)</span>
              </div>
              <div class="mt-1">
                <span style="color:red; margin-top: 2px;">*Optimum banner size: 1692 x 323 pixels</span>
              </div>
              
              <div v-if="bannerSettings.base64Image" class="mt-2">
                <b-img :src="bannerSettings.base64Image" fluid height="90px" />
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="12" class="mt-2">
            <b-button
              variant="primary"
              @click="saveBanner"
              class="me-2 my-1"
            >
              Save
            </b-button>
          </b-col>
        </b-row>
      </b-card-actions-container>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { userAccess } from "@/utils/utils";
import { dateFormat } from "@/utils/utils";
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import axios from '@/axios';

export default {
  mixins: [togglePasswordVisibility],
  data() {
    return {
      // Kiosk Password data
      promptPasswordUpdate: false,
      oldPassword: "",
      password: "",
      
      // Ticketing Text data
      runningText: '',
      showSnackbar: false,
      snackbarColor: '',
      snackbarMessage: '',
      lastUpdated: '',
      lastUpdatedBy: '',
      
      // Kiosk Expiry Date data
      expiryDays: 0,
      showExpirySnackbar: false,
      expirySnackbarColor: '',
      expirySnackbarMessage: '',

      // Banner setting
      showSnackbarBanner: false,
      snackbarColorBanner: 'success',
      snackbarMessageBanner: '',
       bannerSettings: {
        isActive: false,
        base64Image: ''
      }
    };
  },
  mounted() {
    this.$store.dispatch("purchase/getKioskPassword");
    this.refetchTicketingText(false,true);
    this.$store.dispatch("purchase/getKioskExpiry").then((res) => {
      this.expiryDays = res.expiryDay;
    });
  },
  methods: {
    dates(date) {
      return dateFormat(date);
    },
    
    // Kiosk Password methods
    updatePassword() {
      this.$store.dispatch('purchase/updateKioskPassword', {
        oldPassword: this.oldPassword,
        password: this.password
      }).then((res) => {
        this.$bvToast.toast('Update Successful', {
          title: 'Success',
          variant: 'success',
          solid: true,
        });
        this.promptPasswordUpdate = false;
      }).catch((err) => {
        console.error(err);
        var message = (err.response.data.errors[0].message) ? err.response.data.errors[0].message : "";
        
        this.$bvToast.toast('Update Failed - ' + message, {
          title: 'Failed',
          variant: 'danger',
          solid: true,
        });
      });
    },
    
    // Ticketing Text methods
    refetchTicketingText(hideOverlay,skipSnackbar) {
      axios.get(`sales-and-purchase/queue-setting`).then((res) => {
        if (res.data.data === null) {
          this.runningText = 'No Data';
          this.showSnackbar = (skipSnackbar) ? false : true;
          this.bannerSettings.base64Image = ''
          this.snackbarColor = 'error';
          this.snackbarMessage = 'No Data Found, Please Insert Data First';
        } else {
          this.runningText = res.data.data.runningText;
          this.bannerSettings.base64Image = res.data.data.image;
          this.lastUpdated = res.data.data.updatedAt;
          this.lastUpdatedBy = res.data.data.updatedBy;
          this.showSnackbar = (skipSnackbar) ? false : true;
          this.snackbarColor = 'success';
          this.snackbarMessage = 'Data Refreshed Successfully';
        }
      }).catch((e) => {
        console.log(e);
        this.showSnackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Error fetching data';
      });
      if (hideOverlay) setTimeout(hideOverlay, 1000);
    },
    saveRunningText() {
      const payload = {
        runningText: this.runningText
      };
      axios.put(`sales-and-purchase/queue-setting`, payload).then((res) => {
        this.showSnackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Data Saved Successfully';
        this.refetchTicketingText(false,true);
      }).catch((e) => {
        console.log(e);
        this.showSnackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Got Error While Saving Data';
      });
    },
    
    // Kiosk Expiry Date methods
    saveExpiryDays() {
      const payload = {
        expiryDay: parseInt(this.expiryDays)
      };
      this.$store.dispatch('purchase/updateKioskExpiry', payload)
        .then((res) => {
          this.showExpirySnackbar = true;
          this.expirySnackbarColor = 'success';
          this.expirySnackbarMessage = 'Expiry Days Updated Successfully';
        })
        .catch((e) => {
          console.error(e);
          this.showExpirySnackbar = true;
          this.expirySnackbarColor = 'error';
          this.expirySnackbarMessage = 'Error Updating Expiry Days';
        });
    },
     handleFileUpload(event) {
      const file = event.target.files[0];
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
      const maxSize = 1 * 1024 * 1024;
      if (!file) return;

      if (file) {
        if (!allowedTypes.includes(file.type)) {
          this.$bvToast.toast('Only PNG, JPG, and JPEG files are allowed.', {
            title: 'Failed',
            variant: 'danger',
            solid: true
          });
          return;
        }

        if (file.size > maxSize) {
          this.$bvToast.toast('Maximum file size is 1MB.', {
            title: 'Failed',
            variant: 'danger',
            solid: true
          });
          return;
        }
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.bannerSettings.base64Image = e.target.result; // Base64 string
      };
      reader.readAsDataURL(file);
    },

    saveBanner() {
      if (!this.bannerSettings.base64Image) {
        this.snackbarColorBanner = 'danger';
        this.snackbarMessageBanner = 'Please upload a banner image.';
        this.showSnackbarBanner = true;
        return;
      }

       const payload = {
        image: this.bannerSettings.base64Image
      };

      axios.put(`sales-and-purchase/queue-setting`, payload).then((res) => {
        this.showSnackbarBanner = true;
        this.snackbarColorBanner = 'success';
        this.snackbarMessageBanner = 'Data Saved Successfully';
        this.refetchTicketingText(false,true);
      }).catch((e) => {
        console.log(e);
        this.showSnackbarBanner = true;
        this.snackbarColorBanner = 'error';
        this.snackbarMessageBanner = 'Got Error While Saving Data';
      });
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon';
    },
    permission() {
      return userAccess("Kiosk Settings", "settings_menu");
    },
    kioskPassword() {
      return this.$store.getters["purchase/kioskPassword"];
    },
    kioskExpiry() {
      return this.$store.getters["purchase/kioskExpiry"] || {};
    }
  },
  created() {
    document.title = "Kiosk Settings | RSP";
  }
};
</script>

<route lang="yaml">
meta:
  subject: Kiosk Settings
  requiresAuth: true
</route>
